"use client";

import { Check, Flower2, Leaf, Ribbon } from "lucide-react";
import { Link } from "@/components/common/Link";
import { Button } from "@/components/ui/button";
import { useRevealOnScroll } from "@/hooks/useRevealOnScroll";
export default function MapProductsServicesToIndustry() {
  const header = useRevealOnScroll<HTMLDivElement>({
    threshold: 0.2
  });
  const tiers = [{
    number: "01",
    Icon: Flower2,
    name: "Industrial Engraving",
    descriptor: "Precision marking for heavy-duty components.",
    benefits: ["High-contrast metal etching", "Durable industrial finishes", "Strict compliance standards"],
    featured: false
  }, {
    number: "02",
    Icon: Leaf,
    name: "Arc Flash Solutions",
    descriptor: "Safety-first labeling for electrical systems.",
    benefits: ["NFPA 70E compliant labels", "UV-resistant materials", "Custom hazard identification"],
    featured: true
  }, {
    number: "03",
    Icon: Ribbon,
    name: "Phenolic Tagging",
    descriptor: "Reliable identification for complex infrastructure.",
    benefits: ["Multi-layer phenolic engraving", "Custom color-coded systems", "Weather-resistant mounting"],
    featured: false
  }];
  return <section data-section-id="549" id="map-products-services-to-industry" className="bg-background text-foreground py-24 md:py-32">
      <div className="mx-auto max-w-7xl px-6 md:px-10">
        {}
        <div ref={header.ref} className={`mx-auto max-w-3xl text-center transition-all duration-700 ease-out ${header.isVisible ? "opacity-100 translate-y-0" : "opacity-0 translate-y-6"}`}>
          <p className="font-default text-xs tracking-[0.35em] uppercase" style={{
          color: "var(--primary)"
        }}>
            Our Capabilities
          </p>
          <h2 className="font-default text-4xl md:text-5xl lg:text-6xl font-light text-foreground mt-6 leading-[1.05]">
            <em className="italic font-light" style={{
            color: "var(--primary)"
          }}>
              Precision
            </em>{" "}
            Industrial Marking
          </h2>
          <p className="font-default text-base md:text-lg text-muted-foreground mt-6 max-w-xl mx-auto">
            Engineered solutions designed to meet the rigorous demands of modern manufacturing and infrastructure.
          </p>
          <div className="mx-auto mt-10 h-px w-16" style={{
          backgroundColor: "var(--primary)"
        }} />
        </div>

        {}
        <div className="mt-20 grid grid-cols-1 md:grid-cols-3 gap-12 md:gap-0 relative">
          {tiers.map((tier, i) => {
          const Icon = tier.Icon;
          return <div key={tier.number} data-index={i} className={`group relative flex flex-col items-center text-center px-6 md:px-8 py-10 md:py-14 transition-all duration-500 ease-out hover:-translate-y-1 hover:shadow-lg ${tier.featured ? "md:-my-6 md:py-20 bg-card md:scale-[1.03] z-10" : ""} ${i > 0 ? "md:border-l md:border-border" : ""}`}>
                {tier.featured && <p className="font-default text-[10px] tracking-[0.35em] uppercase mb-4" style={{
              color: "var(--primary)"
            }}>
                    Industry Standard
                  </p>}

                {}
                <div className={`font-default italic font-light leading-none ${tier.featured ? "text-7xl md:text-8xl" : "text-6xl md:text-7xl"}`} style={{
              color: "var(--primary)"
            }}>
                  {tier.number}
                </div>

                {}
                <div className="mt-8 transition-transform duration-500 ease-out group-hover:rotate-[5deg]">
                  <Icon className="w-12 h-12 stroke-[1]" style={{
                color: "var(--primary)"
              }} />
                </div>

                {}
                <h3 className="font-default font-light text-2xl md:text-[28px] text-foreground mt-8 leading-tight">
                  {tier.name}
                </h3>

                {}
                <p className="font-default italic text-base md:text-lg text-muted-foreground mt-3 max-w-xs">
                  {tier.descriptor}
                </p>

                {}
                <div className="mt-8 h-px w-12" style={{
              backgroundColor: "var(--primary)"
            }} />

                {}
                <ul className="mt-8 space-y-3 text-left">
                  {tier.benefits.map((benefit, bi) => <li key={bi} data-index={bi} className="flex items-start gap-3 font-default text-sm text-foreground/85">
                      <Check className="w-4 h-4 mt-0.5 stroke-[1.25] shrink-0" style={{
                  color: "var(--primary)"
                }} />
                      <span>{benefit}</span>
                    </li>)}
                </ul>

                {}
                <div className="mt-10">
                  <Button asChild variant="link" className="font-default italic text-base p-0 h-auto hover:no-underline" style={{
                color: "var(--primary)"
              }}>
                    <Link to={i === 1 ? "/ArcFlashLabelsPage" : i === 2 ? "/PhenolicPage" : "/CapabilitiesPage"}>
                      <span className="relative">
                        Learn More{" "}
                        <span className="inline-block transition-transform duration-300 group-hover:translate-x-1">
                          &rarr;
                        </span>
                      </span>
                    </Link>
                  </Button>
                </div>
              </div>;
        })}
        </div>
      </div>
    </section>;
}